import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';
import { CouponListOption, CouponListData } from '../../../types/coupons/list-v2';

type CouponManagementListResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponManagementList>>;

/**
 * V1 API 요청 형태로 변환
 * saga에서 setRequestForm(payload, true) → { data: payload, isSpinner: true } 형태로 전송하고
 * 서버에서는 searchOption, filterOption, sortOption, pagination을 그대로 받음
 */
const toV1RequestPayload = (option: CouponListOption) => ({
  searchOption: option.searchOption ?? {},
  filterOption: option.filterOption ?? {},
  sortOption: option.sortOption
    ? [{ id: option.sortOption.startsWith('-') ? option.sortOption.slice(1) : option.sortOption, desc: option.sortOption.startsWith('-') }]
    : [{ id: 'createDate', desc: true }],
  pagination: {
    pageNum: option.page,
    pageSize: option.pageSize,
  },
});

export const useCouponListQuery = (
  option: CouponListOption,
  options?: UseQueryOptions<CouponManagementListResponse, AxiosError, CouponListData>,
): UseQueryResult<CouponListData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponList(option),
    () => CouponApiV2.getCouponManagementList(toV1RequestPayload(option)),
    {
      select: (res: CouponManagementListResponse) => ({
        totalCount: res.data.totalCnt ?? 0,
        list: res.data.couponList ?? [],
      } as CouponListData),
      ...options,
    },
  );
};
